import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHolidayListContext } from "context/HolidayListContext";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { months, daysOfWeek } from "constant";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import HolidayFormModal from "./HolidayFormModal";
import ImportHolidayModal from "./ImportHolidayModal";
import DeleteHolidayModal from "./DeleteHolidayModal";
import { toast, ToastContainer } from "react-toastify";

import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import CrossIcon from "../../../assets/img/file-cut-icon.png";
import {
  fetchAllHoliday,
  updateHoliday,
  createHoliday,
  publishHoliday,
  deleteHoliday,
  HRViewHoliday,
  getHolidayById,
  clearSelectedEditYear,
} from "../../../redux/slice/getAllHolidaySlice";
import { useHasPermission } from "../../../hooks/useHasPermission";
import { ConsoleView } from "react-device-detect";
const CreateHoliday = () => {
  const dispatch = useDispatch();

  const canManageHoliday = useHasPermission("Holiday-manage");
  const canDeleteHoliday = useHasPermission("Holiday-delete");
  const canManagePublishHoliday = useHasPermission("Holiday-Publish-manage");
  const canDeletePublishHoliday = useHasPermission("Holiday-Publish-delete");

  const [year, setYear] = useState(new Date().getFullYear());
  const holidays = useHolidayListContext();

  const [showFormModal, setShowFormModal] = useState(false);
  const [formMode, setFormMode] = useState("add");
  const [formData, setFormData] = useState({});
  const [showImportModal, setShowImportModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [holidayToDelete, setHolidayToDelete] = useState(null);
  const [expandedHoliday, setExpandedHoliday] = useState(null);
  const selectedEditYear = useSelector(
    (state) => state.allHolidayData.selectedEditYear
  );
  const [holidayYear, setHolidayYear] = useState(
    selectedEditYear || new Date().getFullYear()
  );

  const toggleHoliday = (id) => {
    setExpandedHoliday((prevId) => (prevId === id ? null : id));
  };

  const AllHoliday = useSelector((state) => state.allHolidayData.HRViewHoliday.holidayResponseDtos);
  const HolidayStatus = useSelector((state) => state.allHolidayData.HRViewHoliday.status);

  //console.log('Holidays calendar status======', HolidayStatus)
  //console.log("HRViewHoliday", HRViewHoliday);
  useEffect(() => {
    //console.log("FETCH API CALLED");
    dispatch(HRViewHoliday(holidayYear));
  }, [holidayYear, dispatch]);

  useEffect(() => {
    if (selectedEditYear) {
      setHolidayYear(selectedEditYear);
      setYear(selectedEditYear);

      dispatch(HRViewHoliday(selectedEditYear));

      // optional
      dispatch(clearSelectedEditYear());
    }
  }, [selectedEditYear, dispatch]);

  const getDayOfWeek = (dateString) => {
    const days = [
      "SUNDAY",
      "MONDAY",
      "TUESDAY",
      "WEDNESDAY",
      "THURSDAY",
      "FRIDAY",
      "SATURDAY",
    ];

    return days[new Date(dateString).getDay()];
  };
  const handleAddHolidaySubmit = async () => {
    if (!validateForm()) return;
    const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: getDayOfWeek(toDate),
      holidayType: holidayType,
      isMandatory: true,
    };

    try {
      const result = await dispatch(createHoliday(holidayData));
      setShowEditModal(false);
      resetForm();
      dispatch(HRViewHoliday(holidayYear));
    } catch (error) {
      console.log(error);
    }
  };

  const selectedHoliday = useSelector(
    (state) => state.allHolidayData.selectedHoliday,
  );
  useEffect(() => {
    if (selectedHoliday) {
      setTitle(selectedHoliday.holidayName || "");
      setToDate(selectedHoliday.holidayDate || "");
      setHolidayType(selectedHoliday.holidayType || "");
      setDescription(selectedHoliday.holidayDescription || "");
      setEditHolidayId(selectedHoliday.id);
      setIsEditMode(true);
      setShowEditModal(true);
    }
  }, [selectedHoliday]);

  const handleUpdateHoliday = async () => {
    const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: getDayOfWeek(toDate),
      holidayType: holidayType,
      isMandatory: true,
    };

    try {
      const result = await dispatch(updateHoliday({ id: editHolidayId, holidayData }),);
      setShowEditModal(false);
      resetForm();
      dispatch(HRViewHoliday(holidayYear));

    } catch (error) {
      console.log(error);
    }
  };

  const validateForm = () => {
    let validationErrors = {};

    if (!title.trim()) {
      validationErrors.title = "Title is required";
    }

    if (!holidayType) {
      validationErrors.holidayType = "Holiday Type is required";
    }

    setErrors(validationErrors);

    return Object.keys(validationErrors).length === 0;
  };

  const resetForm = () => {
    setTitle("");
    setToDate("");
    setHolidayType("");
    setDescription("");
    setEditHolidayId(null);
    setIsEditMode(false);
    setErrors({});
  };

  const handlePublishHoliday = async () => {
    try {
      const resultAction = await dispatch(publishHoliday(year));
      if (publishHoliday.fulfilled.match(resultAction)) {
        console.log("Holiday Published Successfully");
      } else {
        console.log(resultAction.payload);
      }
    } catch (error) {
      console.log("Publish API Error", error);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const resultAction = await dispatch(deleteHoliday(holidayToDelete.id));
      dispatch(HRViewHoliday(holidayYear));
      setShowDeleteModal(false);
    } catch (error) {
      console.log("Delete API Error", error);
    }
  };

  const handleAddClick = () => {
    setFormMode("add");
    setFormData({ name: "", date: "", type: "" });
    setShowFormModal(true);
  };

  const handleEditClick = (holiday) => {
    setIsEditMode(true);
    setEditHolidayId(holiday.id);
    setTitle(holiday.holidayName || "");
    setToDate(holiday.holidayDate || "");
    setHolidayType(holiday.holidayType || "");
    setDescription(holiday.holidayDescription || "");
    setShowEditModal(true);
  };

  const handleDeleteClick = (holiday) => {
    setHolidayToDelete(holiday);
    setShowDeleteModal(true);
  };
  const handleFormSubmit = () => {
    if (formMode === "add") {
      // console.log("Adding new holiday:", formData);
    } else {
      // console.log("Updating holiday:", formData);
    }
    setShowFormModal(false);
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [title, setTitle] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [holidayType, setHolidayType] = useState("");
  const [description, setDescription] = useState("");
  const [editHolidayId, setEditHolidayId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [errors, setErrors] = useState({});

  const generateMonthDays = (monthIndex) => {
    const firstDay = new Date(year, monthIndex, 1).getDay();
    const totalDays = new Date(year, monthIndex + 1, 0).getDate();
    const today = new Date();

    let days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${monthIndex}-${i}`} className="empty"></div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const isToday =
        today.getFullYear() === year &&
        today.getMonth() === monthIndex &&
        today.getDate() === day;
      const holidayData = AllHoliday?.find((holiday) => {
        const holidayDate = new Date(holiday.holidayDate);
        return (
          holidayDate.getFullYear() === year &&
          holidayDate.getMonth() === monthIndex &&
          holidayDate.getDate() === day
        );
      });
      const isHoliday = holidayData;
      const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

      days.push(
        <div
          key={`day-${monthIndex}-${day}`}
          className={`day ${isToday ? "today" : ""} ${isHoliday ? "holiday" : ""}`}
          onClick={() => {
            if (!canManageHoliday) return;
            resetForm();
            setToDate(formattedDate);
            if (holidayData?.id) {
              dispatch(getHolidayById(holidayData.id));
            }
            setShowEditModal(true);
          }}
        >
          {" "}
          {day}{" "}
        </div>,
      );
    }
    return days;
  };
  return (
    <div className="container-fluid calendar-fluid calendar-box">
      <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
        <div className="icons-list">
          <Breadcrumb />
        </div>
      </div>
      <div className="holidays-section">
        <div className="d-flex justify-content-between align-items-center">
          <div style={{ cursor: "pointer" }}
            onClick={() => {
              setHolidayYear((prev) => prev - 1);
              setYear(year - 1);
            }}
          >
            <Button type="button" className="primary-btn">
              <i className="fas fa-chevron-left"></i> {year - 1}
            </Button>
          </div>
          <div>
            <h5 className="mb-0">Holidays Calendar - {holidayYear}, <label className="mb-0">Status: - {HolidayStatus ?? "This year's calendar has not been created yet"}</label></h5>
          </div>
          <div style={{ cursor: "pointer" }}
            onClick={() => {
              setHolidayYear((prev) => prev + 1);
              setYear(year + 1);
            }}
          >
            <Button type="button" className="primary-btn ml-4">
              {year + 1} <i className="fas fa-chevron-right"></i>
            </Button>
          </div>
        </div>
        <div className="holidays-scroll-area mt-3">
          <div className="holidays-grid">
            {AllHoliday?.map((holiday) => {
              const uniqueId = `holiday-${holiday?.id}`;
              const menuActions = [
                {
                  label: "Edit",
                  icon: require("assets/img/edit-icon.png"),
                  permission: canManageHoliday || canManagePublishHoliday && (HolidayStatus !== "PUBLISHED"),
                  show: canManageHoliday || canManagePublishHoliday && (HolidayStatus !== "PUBLISHED"),
                  onClick: () => handleEditClick(holiday),
                },
                {
                  label: "Delete",
                  icon: require("assets/img/delete.png"),
                  permission: canDeleteHoliday || canDeletePublishHoliday && (HolidayStatus !== "PUBLISHED"),
                  show: canDeleteHoliday || canDeletePublishHoliday && (HolidayStatus !== "PUBLISHED"),
                  onClick: () => handleDeleteClick(holiday),
                },
              ];

              return (
                <div key={uniqueId} className="holiday-item"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderLeft: "4px solid #6f42c1",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "start",
                  }}
                >
                  <div className="holiday-header d-flex justify-content-between align-items-center p-0" onClick={() => toggleHoliday(uniqueId)} style={{ cursor: "pointer" }}>
                    <span style={{ fontWeight: "500", color: "#333", fontSize: "14px", }}>
                      {holiday.holidayName}
                    </span>

                    <div className="d-flex align-items-center">
                      <span
                        className="me-2 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {holiday.holidayDate}
                      </span>
                      {canManageHoliday && (HolidayStatus !== "PUBLISHED") && (
                        <div onClick={(e) => e.stopPropagation()}>
                          <PopupState
                            variant="popover"
                            popupId={`popup-${uniqueId}`}
                          >
                            {(popupState) => (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-icon pt-0 pb-0 btn-sm"
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  {...bindTrigger(popupState)}
                                >
                                  <img
                                    src={require("assets/img/more.png")}
                                    alt="more"
                                    style={{ width: "14px", opacity: 0.6 }}
                                  />
                                </button>
                                <Menu {...bindMenu(popupState)}>
                                  {menuActions
                                    .filter((action) => action.show)
                                    .map((action, index) => (
                                      <MenuItem
                                        key={index}
                                        disabled={!action.permission}
                                        onClick={() => {
                                          popupState.close();
                                          if (action.permission)
                                            action.onClick();
                                        }}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-sm icons me-2"
                                          title={
                                            action.permission
                                              ? action.label
                                              : "No permission"
                                          }
                                          disabled={!action.permission}
                                        >
                                          <img
                                            src={action.icon}
                                            alt={action.label}
                                            className="action-icon"
                                            style={{
                                              opacity: action.permission
                                                ? 1
                                                : 0.5,
                                            }}
                                          />
                                        </button>
                                        {action.label}
                                      </MenuItem>
                                    ))}
                                </Menu>
                              </>
                            )}
                          </PopupState>
                        </div>
                      )}
                      <i
                        className={`ms-2 fas ${expandedHoliday === uniqueId ? "fa-chevron-up" : "fa-chevron-down"}`}
                        style={{ fontSize: "12px", color: "#ccc" }}
                      ></i>
                    </div>
                  </div>

                  {expandedHoliday === uniqueId && (
                    <div
                      style={{
                        padding: "12px 16px",
                        borderTop: "1px solid #f0f0f0",
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontSize: "13px",
                          color: "#6c757d",
                          lineHeight: "1.5",
                        }}
                      >
                        {holiday.holidayDescription ||
                          "No description available for this holiday."}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="calendar-container mt-4">
        <h3 className="year-heading">{year}</h3>
        <div className="year-grid">
          {months.map((month, index) => (
            <div key={month} className="month">
              <h5>{month}</h5>
              <div className="weekdays">
                {daysOfWeek.map((day) => (
                  <div key={day} className="weekday">
                    {day}
                  </div>
                ))}
              </div>
              <div className="days-grid">{generateMonthDays(index)}</div>
            </div>
          ))}
        </div>
      </div>
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Update Holiday" : "Add Holiday"}
          </Modal.Title>
          <button onClick={() => setShowEditModal(false)} className="modal-close">
            <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                Title <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter title"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setErrors(prev => ({ ...prev, title: "" }));
                }}
                isInvalid={!!errors.title}
              />

              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Holiday Type <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Select
                value={holidayType}
                onChange={(e) => {
                  setHolidayType(e.target.value);
                  setErrors(prev => ({ ...prev, holidayType: "" }));
                }}
                isInvalid={!!errors.holidayType}
                style={{ height: "38px" }}
              >
                <option value="">Select holiday type</option>
                <option value="PUBLIC_HOLIDAY">Public Holiday</option>
                <option value="NATIONAL_HOLIDAY">National Holiday</option>
                <option value="FESTIVAL_HOLIDAY">Festival Holiday</option>
                <option value="COMPANY_HOLIDAY">Company Holiday</option>
                <option value="REGIONAL_HOLIDAY">Regional Holiday</option>
                <option value="RESTRICTED_HOLIDAY">Restricted Holiday (RH)</option>
                <option value="SPECIAL_HOLIDAY">Special Holiday</option>
              </Form.Select>

              <Form.Control.Feedback type="invalid">
                {errors.holidayType}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                placeholder="Enter description"
                type="text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="cancel-cta" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
          <Button
            variant="update-cta"
            onClick={() => {
              if (isEditMode) {
                handleUpdateHoliday();
              } else {
                handleAddHolidaySubmit();
              }
            }}
          >
            {isEditMode ? "Update Holiday" : "Add Holiday"}
          </Button>
        </Modal.Footer>
      </Modal>

      <HolidayFormModal
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
        mode={formMode}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        canEdit={true}
      />

      <DeleteHolidayModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={handleDeleteConfirm}
        holidayName={holidayToDelete?.name || ""}
      />
      <ToastContainer />
    </div>
  );
};

export default CreateHoliday;
